/**
 * Admin configuration
 * Uses VITE_ADMIN_SECRET_PATH from .env for security
 */

function getAdminBasePath(): string {
  const secretPath = import.meta.env.VITE_ADMIN_SECRET_PATH;
  if (
    secretPath &&
    typeof secretPath === "string" &&
    secretPath.trim().length > 0
  ) {
    // Remove leading/trailing slashes
    return secretPath.replace(/^\/+|\/+$/g, "");
  }
  return "admin";
}

export const ADMIN_PATH = getAdminBasePath();

// API endpoints
export const ADMIN_API = {
  login: `/api/${ADMIN_PATH}/login`,
  session: `/api/${ADMIN_PATH}/session`,
  logout: `/api/${ADMIN_PATH}/logout`,
};

// Frontend routes
export const ADMIN_ROUTES = {
  login: `/${ADMIN_PATH}/login`,
  blog: `/${ADMIN_PATH}/blog`,
  blogNew: `/${ADMIN_PATH}/blog/new`,
  blogEdit: (slug: string) => `/${ADMIN_PATH}/blog/edit/${slug}`,
  blogSettings: `/${ADMIN_PATH}/blog/settings`,
};
